export const BOTAO_CLICADO_SUCCESS = 'BOTAO_CLICADO_SUCCESS'; 
export const BOTAO_CLICADO_REQUEST = 'BOTAO_CLICADO_REQUEST';
export const BOTAO_CLICADO_FAILURE = 'BOTAO_CLICADO_FAILURE';  

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const PERSIST_REHYDRATE = 'persist/REHYDRATE';


export const CLICOU_MENU = 'CLICOU_MENU';

export const CLICOU_CARRINHO = 'CLICOU_CARRINHO';

export const CLICOU_BOTAO_COMPRAR = 'CLICOU_BUTAO_COMPRAR';

export const ADD_ONE_PRODUCT = 'ADD_ONE_PRODUCT';
export const REMOVE_ONE_PRODUCT = 'REMOVE_ONE_PRODUCT'; 
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
